import axios from "axios";
import API from "./API";
import Endpoints from "@/V3/Config/Endpoints";

export default {
    fetchLocks: function(centreId, query) {
        return axios.get(
            API.url(Endpoints.Hardware.FetchLocks + '?q=' + query, {centre_id: centreId})
        ).then((res) => {
            return res.data.locks;
        });
    }
};
